import {trackOnNextPageImpression} from "@otto-ec/tracking-bct";
import {Logger} from "./logger";
import {DATA_TRACKED_ATTRIBUTE, DATA_TRACKED_VALUE} from "./types";
import {unlockInit} from "@otto-ec/global-resources/tracking";
import {enhanceTracking} from "@otto-ec/ft3_frontend-tracking/lib/attribute-based-tracking-functions";

export class TopicPromoNew {

    static init(): void {
        Logger.group("[FT3 promo topicpromo]");
        Logger.count("Topicpromo Invocation");

        [...document.querySelectorAll('.promo_topicpromo--container')]
            .filter((topicpromoContainer: Element) => topicpromoContainer.getAttribute(DATA_TRACKED_ATTRIBUTE) !== DATA_TRACKED_VALUE)
            .forEach((topicpromoContainer: Element) => {
                topicpromoContainer.setAttribute(DATA_TRACKED_ATTRIBUTE, DATA_TRACKED_VALUE);
                const topicpromoCard = topicpromoContainer.querySelector(".promo_topicpromo__card");
                if (topicpromoCard) {
                    this.trackClick(topicpromoCard);
                    enhanceTracking(topicpromoContainer, topicpromoCard, "TopicPromotionLarge");
                }
            });
        unlockInit("ft3.topicpromo.lock.token");

        Logger.groupEnd();
    }

    private static trackClick(container: Element): void {
        container?.addEventListener("click", () => trackOnNextPageImpression({"promo_Click": ["TopicPromotionLarge"]}));
    }

}
